// extracted by mini-css-extract-plugin
export var isActive = "Navigation-module--isActive--afRny";